import { render, staticRenderFns } from "./Points_history.vue?vue&type=template&id=34a2ef0d"
import script from "./Points_history.vue?vue&type=script&lang=js"
export * from "./Points_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports